<template>
  <component :is="type" :aria-label="ariaLabel" class="svg-icon"> </component>
</template>

<script>
const cache = new Map();
const req = require.context(`${__dirname}/../../assets/icons/`, true, /^\.\/.*\.svg$/);

/**
 *
 */
export default {
  name: "SvgIcon",

  props: {
    /**
     * The name of the icon to display.
     */
    name: {
      type: String,
      required: true,
      default: "settings",
    },
    /**
     * The fill color of the SVG icon.
     */
    fill: {
      type: String,
      default: "#00264c",
    },
    /**
     * Descriptive text to be read to screenreaders.
     */
    ariaLabel: {
      type: String,
      default: "icon",
    },
    /**
     * The html element name used for the icon.
     */
    type: {
      type: String,
      default: "span",
    },
    /**
     * The size of the icon.
     */
    size: {
      type: String,
      default: "16px",
    },
  },
  watch: {
    async name() {
      await this.loadIcon();
    },
  },
  async mounted() {
    await this.loadIcon();
  },
  methods: {
    async loadIcon() {
      const currPath = req(`./${this.name}.svg`);
      if (!cache.has(currPath)) {
        try {
          cache.set(
            currPath,
            fetch(currPath).then(r => r.text())
          );
        } catch (e) {
          cache.delete(currPath);
        }
      }
      if (cache.has(currPath)) {
        this.$el.innerHTML = await cache.get(currPath);
        this.$el.children[0].style.fill = this.fill;
        this.$el.children[0].style.width = this.size;
        this.$el.children[0].style.height = this.size;
      }
    },
  },
};
</script>
